import {UPDATE_EVENT_DETAILS} from '~/common/fabric/reducers/details/constants';
import {qsArrayTransform} from '~/CreateGreetingCard/utils/navigation';

export const getLastPathComponent = (path) => {
  const components = path.split('/');
  return components[components.length - 1];
};

const getGalleryUrl = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const category = urlParams.get('c');
  const page = urlParams.get('page');
  const filter = qsArrayTransform('filter');

  return category && page ? `/gallery/category/${category}/${page}?${filter}` : '/';
};

export const backToGallery = () => {
  window.location.href = getGalleryUrl();
};

export const setInEditMode = async (store) => {
  store.dispatch({
    type: UPDATE_EVENT_DETAILS,
    payload: {inEditMode: true},
  });
  return true; // allow navigation
};
